<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新建工单
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    custom-class="new-workorder"
    title="克隆工单"
    :visible.sync="dialogShow"
    top="10vh"
    width="600px"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <div v-loading="loading" style="width: 500px; margin: 0px auto 20px">
      <el-form ref="workorderForm" :model="workorder" :rules="workorderRules" label-position="left" label-width="120px">
        <el-form-item label="工单号" prop="workorder_no">
          <el-row>
            <el-col :span="11">
              <el-input v-model="workorder.workorder_no" clearable />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="制号">
          <mes-num-selector v-model="workorder.mfgid" placeholder="选择制号" />
        </el-form-item>
        <el-form-item label="部件">
          <part-selector v-model="workorder.mid" :no="workorder.material_title" :mfgid="workorder.mfgid" placeholder="选择部件" />
        </el-form-item>
        <el-form-item label="工序内容" prop="processid">
          <pp-process-selector v-model="workorder.processid" placeholder="请选择" :no="workorder.process_no" @change="getProcess" />
          <div v-if="process_remark" class="mt process-remark">
            <div>备注信息：</div>
            <div>{{process_remark}}</div>
          </div>
        </el-form-item>
        <el-form-item label="派工工时" prop="standard_hour">
          <el-row>
            <el-col :span="11">
              <div class="flex align-items-center">
                <el-input-number v-model="workorder.standard_hour" :min="0" :controls="false" placeholder="额定工时" style="width: 120px"></el-input-number>
                <span class="ml-xs">{{unit}}/件</span>
              </div>
            </el-col>
            <el-col :span="11" :offset="2">
              <div class="flex align-items-center">
                <el-input-number v-model="workorder.add_hour" :min="0" :controls="false" placeholder="附加工时" style="width: 120px"></el-input-number>
                <span class="ml-xs">{{unit}}</span>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="派工数量" prop="plan_num">
          <div class="flex align-items-center">
            <el-input-number v-model="workorder.plan_num" :controls="false" :precision="1" :min="0.1" style="width:120px"></el-input-number>
            <span class="ml-xs">件</span>
          </div>
        </el-form-item>
        <el-form-item label="工位">
          <pp-station-selector v-model="workorder.stationid" placeholder="请选择" />
        </el-form-item>
        <el-form-item label="计划时间" prop="plan_endtime">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="—"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            :default-time="['8:00:00', '18:00:00']"
            style="width: 100%;"
          />
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="workorder.remark" size="small" type="textarea" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="text-center mb">
      <el-button plain class="extend" @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" class="extend" @click="submit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getMesWorkorderApi,
  postMesWorkorderApi,
  preWorkorderNoApi,
} from "@/api/mes/workorderApi";
import { mapState } from "vuex";
export default {
  name: "CloneWorkorder",

  components: {
    MesNumSelector: () => import("@/views/mes/components/MesNumSelector"),
    PpStationSelector: () => import("@/views/pp/components/PpStationSelector"),
    PpProcessSelector: () => import("@/views/pp/components/PpProcessSelector"),
    PartSelector: () => import("@/views/mm/components/PartSelector"),
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    workorderid: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
      process_remark: "",
      workorder_standard_unit: "",
      workorder: {
        workorder_no: null,
        workorderid: null,
        processid: null,
        mid: null,
        mfgid: null,
        plan_starttime: null,
        plan_endtime: null,
        standard_hour: null,
        add_hour: null,
        plan_num: 1,
        stationid: null,
        remark: "",
      },
      workorderRules: {
        workorder_no: [
          { required: true, message: "工单号不能为空", trigger: "blur" },
        ],
        processid: [
          { required: true, message: "工序不能为空", trigger: "change" },
        ],
      },
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    ...mapState({
      unit(state) {
        let temp = state.godStore.god_setting.workorder_standard_unit || "";
        switch (temp) {
          case "hour":
            return "h";
          case "minute":
            return "min";
          case "second":
            return "s";
        }
      },
    }),

    time: {
      get() {
        if (this.workorder.plan_starttime && this.workorder.plan_endtime) {
          return [
            this.workorder.plan_starttime * 1000,
            this.workorder.plan_endtime * 1000,
          ];
        } else {
          return null;
        }
      },
      set(val) {
        if (val !== null) {
          this.workorder.plan_starttime = val[0] / 1000;
          this.workorder.plan_endtime = val[1] / 1000;
        }else {
          this.workorder.plan_starttime = '';
          this.workorder.plan_endtime = '';
        }
      },
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      getMesWorkorderApi({ workorderid: this.workorderid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.workorder = Object.assign({}, res.data);
          this.fetchNo();
        }
      });
    },

    fetchNo() {
      this.loading = true;
      preWorkorderNoApi().then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.workorder.workorder_no = res.data;
          this.$store.dispatch("getUserInfoAction").then((res) => {
            if (!res.errno) {
              this.workorder_standard_unit = res.data.god_setting.standard_unit;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },


    getProcess(e) {
      if (e) {
        this.workorder.standard_hour = e.standard_hour;
        this.workorder.add_hour = e.add_hour;
        this.process_remark = e.remark;
      } else {
        this.process_remark = "";
      }
    },

    submit() {
      this.$refs["workorderForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.workorder.parent_workorderid = this.workorderid;
          this.workorder.workorderid = null;
          this.workorder.create_scene = "clone";
          postMesWorkorderApi(this.workorder).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.$emit("success");
              this.$message.success("工单提交成功");
              this.dialogShow = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.new-workorder {
  .process-remark {
    padding: 12px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(248, 249, 252, 400);
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
}
</style>
